<template>
  <div class="main" v-if="queryData.tzdId">
    <van-nav-bar title="" @click-left="onClickLeft" />
    <template v-if="queryData.state == 2">
      <div class="content">
        <div class="content-sub">
          <div class="top-box">
            <h3>{{ queryData.wyqumc || '--' }}</h3>
            <p>{{ "业主：" + (queryData.yz || '--') }}</p>
          </div>
          <div class="main-box">
            <div class="info-item">
              <span class="desc">房屋名称：</span>
              <p class="detail">
                {{ queryData.fwmc || '--' }}
              </p>
            </div>
            <div class="info-item">
              <span class="desc">建筑面积：</span>
              <p class="detail">{{ (queryData.jzmj || '--') + "m²" }}</p>
            </div>
            <div class="info-item">
              <span class="desc">通知单编号：</span>
              <p class="detail">{{ queryData.tzdh || '--' }}</p>
            </div>
            <div class="info-item">
              <span class="desc">交款类型：</span>
              <p class="detail">{{ queryData.jklx || '--' }}</p>
            </div>
            <div class="info-item">
              <span class="desc">应交金额：</span>
              <p class="detail">
                <span class="left-money">{{ "￥" + (queryData.yjje || '--') }}</span><small class="right-big-money">
                  {{ getChinaNumb(queryData.yjje) || '--' }}
                </small>
              </p>
            </div>
            <div class="info-item">
              <span class="desc">备注：</span>
              <p class="detail">
                {{ queryData.bz ? queryData.bz : "--" }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="instruction">
        <span>说明：</span>
        <!-- <p>
                交存标准：根据《泸州市住宅专项维修资金管理细则》按照建筑安装造价<span
                    class="color-sty-yel"
                    >{{ queryData.jcbz }}</span
                >元/m²。
            </p> -->
        <p>
          通过线下转款或到网点办理交款的业主，需持本通知单及银行交存回执到<span class="color-sty-yel">交款银行网点或代管机构</span>领取交存凭证。
        </p>
      </div>
      <div class="footerBox">
        <span class="left">{{ "￥" + queryData.yjje }}</span>
        <button class="primaryBtn" @click="search" v-show="!getting">
          支付
        </button>
        <button class="getingBtn" v-show="getting">支付中...</button>
      </div>
    </template>
    <template v-else>
      <div class="content suc-sty">
        <div class="content-sub">
          <div class="top-box">
            <h3>{{ queryData.wyqumc || "--" }}</h3>
            <p class="suc-tip"><van-icon name="certificate" />已交存成功</p>
            <p>{{ "业主：" + (queryData.yz || "--") }}</p>
          </div>
          <div class="main-box">
            <div class="info-item">
              <span class="desc">房屋名称：</span>
              <p class="detail">
                {{ queryData.fwmc || "--" }}
              </p>
            </div>
            <div class="info-item">
              <span class="desc">交款人：</span>
              <p class="detail">{{ queryData.jkr || "--" }}</p>
            </div>
            <div class="info-item">
              <span class="desc">交款方式：</span>
              <p class="detail">{{ queryData.jkfs || "--" }}</p>
            </div>
            <div class="info-item">
              <span class="desc">交款时间：</span>
              <p class="detail">{{ queryData.jksj || "--" }}</p>
            </div>
            <div class="info-item">
              <span class="desc">交存金额：</span>
              <p class="detail">
                <span class="left-money">{{
                  "￥" + (queryData.yjje || "--")
                }}</span><small class="right-big-money">
                  {{ getChinaNumb(queryData.yjje) || "--" }}
                </small>
              </p>
            </div>
            <div class="info-item">
              <span class="desc">专户银行：</span>
              <p class="detail">{{ queryData.zhyh || "--" }}</p>
            </div>

            <div class="info-item">
              <span class="desc">交存凭证：</span>
              <p class="detail">
                <span class="inner-pdf-icon"></span>{{ queryData.jcpz || "交款凭证.pdf" }}
                <span @click="emaillShow = true" class="send-sty">发送至邮箱</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>

    <van-overlay :show="emaillShow">
      <div class="wrapper" @click.stop>
        <div class="block">
          <p class="title">是否发送至我的邮箱</p>
          <div class="middle-box">
            <span class="left">
              <span class="inner-pdf-icon"></span>
            </span>
            <span class="middle">{{
  "交款凭证.pdf"
            }}</span><span class="right">1.7M</span>
          </div>
          <div class="bot">
            <van-field v-model="emailInfo" type="email" label="邮箱：" />
          </div>
          <div class="btns">
            <span class="cancel-btn" @click="emaillShow = false">取消</span><span class="end-btn"
              @click="endEmailMet">发送</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { tzdH5, crateOrderId, sendemail } from "@api/deposite.js";
import getChinaNumb from "../utils/moneyFormat";
export default {
  data() {
    return {
      show: false,
      // 请求控制
      getting: false,
      queryData: {},
      //   email控制弹框
      emaillShow: false,
      emailInfo: "",
    };
  },
  methods: {
    getChinaNumb(numb) {
      return getChinaNumb(numb);
    },
    onConfirm(values, index) {
      this.show = false;
    },
    // 取消返回
    // goBack() {
    // },
    onClickLeft() {
      this.$router.go(-1);
    },
    onCancel() {
      this.show = false;
    },
    search() {
      if (!this.queryData.tzdId) {
        return this.$toast({
          message: "支付失败，没有通知单编号，请稍后重试！",
          position: "top",
        });
      }
      this.getting = true;
      crateOrderId(this.queryData.tzdId)
        .then((res) => {
          this.getting = false;
          if (res.data.code == 200 || res.code == 200) {
            return window.open(res.data?.data?.url || res.data?.url || res.data?.data?.msg || res.data?.msg, "_self");
          } else {
            let msg = encodeURI(res.data.msg || res.msg);
            return window.open("/repeatOrder?msg=" + msg, "_self");
          }
        })
        .catch((err) => {
          this.getting = false;
          console.log(err);
          return this.$toast({
            message: "交存失败，请稍后重试！",
            position: "top",
          });
        });
    },
    endEmailMet() {
      // this.emailInfo
      if (
        /^([a-zA-Z\d][\w-]{2,})@(\w{2,})\.([a-z]{2,})(\.[a-z]{2,})?$/.test(
          this.emailInfo
        )
      ) {
        this.emaillShow = false;
        this.$toast.loading({
          message: "发送中...",
          forbidClick: true,
          loadingType: "spinner",
          overlay: true,
          duration: 0
        });

        sendemail({
          email: this.emailInfo,
          tzdId: this.$route.query.tzdid
        })
          .then((res) => {
            this.$toast.clear();
            if (res.status == 200) {
              this.$toast.success('发送成功');
            } else {
              this.$toast.fail('发送失败');
            }
          })
          .catch(() => {
            this.$toast.clear();
            this.$toast.fail('发送失败');
          });
      } else {
        this.$notify({ type: "danger", message: "请输入正确邮箱地址！" });
      }
    },
  },
  mounted() {
    tzdH5({ tzdId: this.$route.query.tzdid })
      .then(({ data: { code, data: innerData } }) => {
        if (code == 200) {
          this.queryData = innerData;
        } else {
          return this.$toast({
            message: "查询失败，请稍后重试！",
            position: "top",
          });
        }
      })
      .catch(() => {
        return this.$toast({
          message: "查询失败，请稍后重试！",
          position: "top",
        });
      });
  },
  created() {
    // if (!this.$route.query.tzdid) {
    //   this.$router.push("?tzdid=80000000073959");
    // }
  },
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "icomoon";
  src: url("../assets/fonts/icomoon.eot?3jk4dz");
  src: url("../assets/fonts/icomoon.eot?3jk4dz#iefix") format("embedded-opentype"),
    url("../assets/fonts/icomoon.ttf?3jk4dz") format("truetype"),
    url("../assets/fonts/icomoon.woff?3jk4dz") format("woff"),
    url("../assets/fonts/icomoon.svg?3jk4dz#icomoon") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}

.inner-pdf-icon {
  margin-right: 3px;
  vertical-align: middle;

  &::after {
    content: "\eadf";
    font-family: "icomoon";
    font-size: 18px;
    font-weight: 600;
    color: #dd0d0d;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 320px;
  background-color: #fff;
  color: #999;

  .title {
    font-size: 20px;
    color: #000000;
    font-weight: 800;
    text-align: center;
  }

  .middle-box {
    display: flex;
    height: 46px;
    line-height: 46px;
    padding: 0 10px;

    .left {
      width: 46px;

      .inner-pdf-icon {
        &::after {
          content: "\eadf";
          font-family: "icomoon";
          font-size: 42px;
          font-weight: 400;
          color: #dd0d0d;
        }
      }
    }

    .middle {
      flex: 1;
      line-height: 41px;
      padding-top: 4px;
      padding-left: 4px;

      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }

    .right {
      width: 60px;
      text-align: center;
    }
  }

  .bot {
    margin-bottom: 20px;

    ::v-deep {
      .van-cell.van-field {
        line-height: 28px;
      }

      .van-field__label {
        width: 46px !important;
        font-size: 16px;

        span {
          display: inline-block;
          width: 100%;
          white-space: nowrap;
        }
      }

      .van-cell__value.van-field__value {
        border: 1px solid #999;
        padding-left: 10px;
      }
    }
  }

  .btns {
    display: flex;
    margin-top: 10px;
    height: 42px;
    line-height: 42px;
    border-top: 1px solid rgb(202, 197, 197);
    font-size: 18px;
    font-weight: 500;
    text-align: center;

    .cancel-btn,
    .end-btn {
      width: 50%;
    }

    .cancel-btn {
      border-right: 1px solid rgb(202, 197, 197);
    }

    .end-btn {
      color: #ff6c1a;
    }
  }
}

.van-nav-bar {
  background-color: rgba(255, 216, 193, 0.42);
}

.van-nav-bar::after {
  border: none;
}

.text-sty {
  font-size: 20px !important;
}

::v-deep .van-icon-arrow-left:before {
  color: #fff;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  line-height: 21px;
}

::v-deep .van-nav-bar__title {
  font-size: 17px;
  font-family: PingFang SC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
}

::v-deep .van-icon {
  color: #000000;
}

::v-deep .van-nav-bar__text {
  color: #000000;
}

::v-deep .van-nav-bar__title {
  color: #000000;
}

.main {
  width: 100%;
  background: #f2f4f8;
  overflow: hidden;
  color: #fff;
  padding-bottom: 80px;

  .content {
    position: relative;
    width: 100%;
    height: 600px;
    box-sizing: border-box;
    font-size: 20px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #222120;
    line-height: 30px;

    .content-sub {
      width: 100%;
      height: 400px;
      background: linear-gradient(180deg,
          rgba(255, 216, 193, 0.42) 0%,
          rgba(255, 216, 193, 0) 100%);
      overflow: hidden;
      padding: 20px 20px 20px;

      .top-box {
        h3 {
          position: relative;
          z-index: 999;
          margin: 0 0 18px;
        }

        p {
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          margin: 0 0 20px;
        }
      }
    }

    .main-box {
      position: absolute;
      top: 114px;
      left: 20px;
      right: 20px;
      height: 486px;
      padding: 16px;
      background: #ffffff;
      border-radius: 0px 0px 0px 0px;

      .info-item {
        margin-bottom: 16px;

        .desc {
          font-size: 16px;
          font-family: P ingFang SC-Semibold, PingFang SC;
          font-weight: 650;
          color: #4e4d4d;
          line-height: 19px;
        }

        .detail {
          margin: 3px 0 0;
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #4e4d4d;
          line-height: 22px;

          .left-money {
            font-size: 16px;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ff3566;
            line-height: 19px;
          }

          .right-big-money {
            font-size: 12px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #999998;
            line-height: 14px;
            margin-left: 20px;
          }
        }
      }

      &::after {
        content: "";
        display: inline-block;
        position: absolute;
        right: 0;
        top: -94px;
        width: 120px;
        height: 120px;
        background: url("../assets/img/house-bk.png");
        background-size: 120px 120px;
        z-index: 1;
      }
    }
  }

  .suc-sty {
    .main-box {
      min-height: 560px;
    }

    .content-sub {
      .top-box {
        h3 {
          margin-bottom: 0;
        }

        p {
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          margin: 0;

          &.suc-tip {
            font-size: 16px;
            font-weight: 600;
          }
        }

        .van-icon-certificate {
          color: #17db17;
          font-weight: 600;
          font-size: 18px;
          margin-right: 2px;
        }
      }
    }

    .send-sty {
      float: right;

      display: inline-block;
      padding: 0 8px;
      height: 26px;
      background-color: #ff6c1a;
      color: #fff;
      line-height: 24px;
      border-radius: 4px;
    }
  }

  .instruction {
    margin: 20px 20px 0;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #4e4d4d;
    line-height: 24px;

    span {
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      color: #999998;
      line-height: 26px;
    }

    span.color-sty-yel {
      color: #ff6c1a;
    }

    p {
      margin: 7px 0 0;
    }
  }

  .footerBox {
    width: 100%;
    height: 60px;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    padding: 20px;
    left: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;

    span {
      font-size: 20px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ff3566;
      line-height: 60px;
    }

    button {

      &.primaryBtn,
      &.getingBtn {
        width: 96px;
        height: 42px;
        background: linear-gradient(133deg, #ff6c19 0%, #ffa370 100%);
        border-radius: 21px 21px 21px 21px;
        opacity: 1;
        border: none;
        font-size: 16px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 19px;
        transition: 0.7s all;
      }

      &.getingBtn {
        background: gray;
      }
    }
  }
}
</style>
